module.exports = __webpack_public_path__ + "static/media/icon-illustration.bbb0d068.svg";